import { Typography,Button, Card, Col, Flex, Row, Space, Table, Tag, Spin } from "antd";
import React, { useState } from "react";
import Title from "antd/es/typography/Title";
import { useEffect } from "react";
import { QuestionOutlined } from "@ant-design/icons";
import { DeleteIcon, EditIcon } from "../../../../../assets/svg";
import { colors } from "../../../../../constants/colors";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Spinner from "../../../../common/spinner/Spinner";
import FaqsFormDialog from "./FaqsFormDialog";
import styles from "./Faqs.module.scss"
import { getFaqsAction } from "../../../../../redux/services/faqs/faqsServices";
import Actions from "../../../../../redux/actions";
import FaqsDeleteDialog from "./FaqsDeleteDialog";
import { appConstConfig } from "../../../../../constants/config/appConstConfig";
import { dateObjToDispViewDate,timeObjToDispViewTimeWithSuffix } from "../../../../../utils/utils";

import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.guess();

const Faqs = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  /* table dependencies */
  const {faqs} = useSelector((state)=>state.faqs)
  const [columns, setColumns] = useState([]);
  const [pagination, setPagination] = useState({
    pageNo : appConstConfig.DEFAULT_TABLE_PAGE_NUMBER,
    pageSize : appConstConfig.DEFAULT_TABLE_PAGE_SIZE
  })
  const paginationObj = {
    total: faqs?.total,
    current:pagination?.pageNo,
    pageSize:pagination?.pageSize,
    onChange: (pageNo, pageSize) => setPagination({pageNo, pageSize}),
    pageSizeOptions:appConstConfig.DEFAULT_PAGE_SIZE_OPTIONS_ARR,
    showSizeChanger: true
  }
  /* table dependencies */

  /* dialog dependencies */
  const [openAddEditFaqsDialog, setOpenAddEditFaqsDialog] = useState(false);
  const [openFaqsDeleteDialog, setOpenFaqsDeleteDialog] = useState(false);
  /* dialog dependencies */

  /* function definition to get table data */
  const handleGetTableData = () => {
    setLoading(true)
    const dataToBeSent = {
      page:pagination?.pageNo,
      limit:pagination?.pageSize
    }
    dispatch(getFaqsAction(dataToBeSent)).then(()=>{
      setLoading(false)
    })
  };
  /* function definition to get table data */

  useEffect(() => {
    handleGetTableData();
  }, [pagination]);

  /* initial dependencies rendering */
  useEffect(() => {
    /* table column config */
    const tempTableColumns = [
      {
        title: t("Modules.Configuration.userType"),
        dataIndex: "faq_for",
        key: "faq_for",
      },
      {
        title: t("Modules.FaqsRevenue.question"),
        dataIndex: "question",
        key: "question",
      },
      {
        title: t("Modules.AutoCredit.status"),
        key: "action",
        align: "center",
        render: (_, record) => {
          const getColorBasedOnStatus = (status) => {
            switch (status) {
              case true:
                return { background: colors.lightTeal, color: colors.darkTeal };
  
              case false:
                return {
                  background: colors.lightPinkishRed,
                  color: colors.darkMaroon,
                };
  
              default:
                break;
            }
          };
          return (
            <>
              <Tag
                bordered={false}
                style={{
                  ...getColorBasedOnStatus(record?.is_active),
                  textTransform: "capitalize",
                }}
              >
                {record?.is_active === true ? t("CommonUtils.active") : t("CommonUtils.inactive")}
              </Tag>
            </>
          );
        },
      },
      {
        title: t("createAt"),
        dataIndex: "created_at",
        key: "created_at",
        render: (_, record) => (
          <p>{`${dateObjToDispViewDate(record?.created_at, "ddmmyyyy")} - ${timeObjToDispViewTimeWithSuffix(dayjs
              .utc(record?.created_at).local().tz(dayjs.tz.guess()).format("YYYY-MM-DDTHH:mm:ss")
          )}`}</p>
        ),
      },
      {
        title: t("appointmentInfo.action"),
        key: "action",
        align:'center',
        render: (_, record) => {
          return (
            <>
            {
              record?.is_active ? 
              <Flex gap="small" justify="center">
                <Space size="middle">
                  <Button
                    type="text"
                    size="medium"
                    icon={<EditIcon fillColor={colors.slateGray} />}
                    onClick={(e) => handleAddEditDetails(e, record)}
                  />
                </Space>
                <Space size="middle">
                  <Button
                    type="text"
                    size="medium"
                    icon={<DeleteIcon fillColor={colors.slateGray} />}
                    onClick={(e) => handleConfirmDelete(e, record)}
                  />
                </Space>
              </Flex>
              :
              <>-</>
            }
            </>
          );
        },
      },
    ];
    /* table column config */
    setColumns(tempTableColumns);
  }, []);
  /* initial dependencies rendering */

  const handleAddEditDetails = (e, row) => {
    setOpenAddEditFaqsDialog(true);
    if (row?._id && row?._id !== "" && row?._id !== null && row?._id !== undefined) {
      const selectedFaqId = row?._id;
      dispatch(Actions.createAction(Actions.SELECTED_FAQ_ID, {selectedFaqId}))
    }
  };

  const handleConfirmDelete = (e, row) => {
    dispatch(Actions.createAction(Actions.SELECTED_FAQ_ID, {selectedFaqId: ""}));
    setOpenFaqsDeleteDialog(true);
    if (row?._id && row?._id !== "" && row?._id !== null && row?._id !== undefined) {
      const selectedFaqId = row?._id;
      dispatch(Actions.createAction(Actions.SELECTED_FAQ_ID, { selectedFaqId }));
    }
  };

  return (
    <div className={styles.faqsContainer}>
        <Flex vertical gap="2rem">
          <Flex align="center" justify="space-between">
            <Card
                  bordered
                  hoverable
                  style={{
                    width: 300,
                    padding: 0,
                    borderRadius: 20,
                    border: `1px solid ${colors.oceanBlue}`,
                  }}
                >
              <Row gutter={[24, 24]} align="middle" justify="center">
                <Col span={6}>
                  <Button
                    type="primary"
                    shape="circle"
                    size="middle"
                    icon={<QuestionOutlined  style={{ fontSize: 22 }} />}
                    style={{ background: colors.oceanBlue }}
                  />
                </Col>
                <Col span={18}>
                  <Flex vertical>
                    <Typography.Title level={3}>
                      {t("AppModuleNames.SuperAdmin.FAQS")}
                    </Typography.Title>
                    <Typography.Title
                      level={2}
                      style={{ margin: 0, color: colors.DarkMint }}
                    >
                      {`${faqs?.total || 0}`}
                    </Typography.Title>
                  </Flex>
                </Col>
              </Row>
            </Card>
            <Button
              type="primary"
              onClick={(e) => handleAddEditDetails(e, null)}
            >
             {t("AppModuleNames.SuperAdmin.ADDFAQS")}
            </Button>
          </Flex>
          {
            loading ? 
            <Spinner />
            :
            <Table 
            dataSource={faqs?.data} 
            columns={columns} 
            pagination={paginationObj}
            />
          }
        </Flex>
      <FaqsFormDialog
        open={openAddEditFaqsDialog}
        onClose={() => {
          setOpenAddEditFaqsDialog(false);
          handleGetTableData();
        }}
      />
      <FaqsDeleteDialog
      open={openFaqsDeleteDialog}
      onClose={() => {
        setOpenFaqsDeleteDialog(false);
        handleGetTableData();
      }}
      />
    </div>
  );
};

export default Faqs;
